import { createSlice } from "@reduxjs/toolkit";
import api from '../Components/_helpers/api';

export const certSlice = createSlice({
  name: "cert",
  initialState: {
    data: {},
    currentFilters: {},
    isLoading: true,
    error: "",
  },
  reducers: {
    requestCert: (state, action) => {
      state.isLoading = true;
      state.currentFilters = action.payload;
    },
    requestCertSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    requestCertFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    updateCert: (state, action) => {
      state.isLoading = true;
    },
    updateCertSuccess: (state, action) => {        

      state.data = {
        ...state.data, //Returns the current state
        items: state.data.items.map(cert => cert.fileId === action.payload.fileId ? // Loop through the array to find the post you want to modify
            { ...action.payload} : cert // Copy the post state and then modify it. Else return the same object.
        )
      }

      state.isLoading = false;
    },
    updateCertFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    }
  },
});

export const { requestCert, requestCertSuccess, requestCertFailure, updateCert, updateCertSuccess, updateCertFailure, setError } = certSlice.actions;

//Thunks
export const requestCertAsync = (payload) => (dispatch) => {
  let filters = payload || {};
  dispatch(requestCert(filters));

  api.post('/Certificado/GetAll', payload).then((data) => {
    dispatch(requestCertSuccess(data.data));
  }).catch(e => {
    console.log(e);
    dispatch(requestCertFailure(e));
  });
};

export const updateCertAsync = (payload) => (dispatch) => {
  dispatch(updateCert(payload));
  api.put(`/Certificado/${payload.id}`, payload.estatus).then((data) => {
    dispatch(updateCertSuccess(data.data));
  }).catch(e => {
    console.log(e);
    dispatch(updateCertFailure(e));
  });
};

//Selector
export const selectData = (state) => state.cert.data;
export const selectIsLoading = (state) => state.cert.isLoading;
export const selectError = (state) => state.cert.error;
export const selectCurrentFilters = (state) => state.cert.currentFilters;

export default certSlice.reducer;
